import React, {Fragment, useState} from 'react'
import {useHistory} from "react-router-dom"

// Material-UI Core
import {makeStyles, withStyles} from '@material-ui/core/styles'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import Typography from '@material-ui/core/Typography'
import Hidden from "@material-ui/core/Hidden"

// Material-UI icon
import AccountCircle from '@material-ui/icons/AccountCircle'

// Custom Component
import ConfirmDialog from '../Dialog/ConfirmDialog'
import {AppBarButton} from '../../styles/jss/components/button'
import SignOut from '../SignIn/SignOut'

// Custom Style
import iconStyle from '../../styles/jss/components/iconStyle'
import userMenuStyle from '../../styles/jss/components/navBar/userMenuStyle'


const UserNameTypography = withStyles({
	root: {
		"fontSize": 16,
		"fontWeight": 800,
		"color": "#0000b3",
	},
}) (Typography)

const iconStyles = makeStyles(iconStyle)
const useStyles = makeStyles(userMenuStyle)

const UserIcon = () => {
    const history = useHistory()
    const iconClasses = iconStyles()
    // const classes = useStyles()
    const store = require('store')
    // const {history} = props

    const [anchorEl, setAnchorEl] = useState(null)
    const open = Boolean(anchorEl)
    
	const [confirmDialogOpen, setConfirmDialogOpen] = useState(false)
	const [confirmDialogData, setConfirmDialogData] = useState({
		dialogTitle: "",
		dialogContent: "",
		confirmAction: "",
		cancelAction: ""
	})


	// Build Confirm Dialog
	const confirmDialogHandleOpen = (data) => {
		setConfirmDialogData({
			dialogTitle: data.dialogTitle,
			dialogContent: data.dialogContent,
			confirmAction: data.confirmAction,
			cancelAction: data.cancelAction
		})

		setConfirmDialogOpen(true)
	}

	const confirmDialogHandleClose = () => {
		setConfirmDialogOpen(false)
	}

    
    // Main Action
	const logoutConfirmAction = () => {
		setAnchorEl(null)

		confirmDialogHandleOpen({
			dialogTitle: "System Logout",
			dialogContent: "Are you sure to logout.",
			confirmAction: () => handleSignOut(),
			cancelAction: logoutCancelAction
		})
	}

	const logoutCancelAction = () => {
		confirmDialogHandleClose()
	}

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const handleSignOut = () => {
        setAnchorEl(null)
        SignOut(history)
    }


    return (
        <Fragment>
            <ConfirmDialog
				open={confirmDialogOpen}
				dialogTitle={confirmDialogData.dialogTitle}
				dialogContent={confirmDialogData.dialogContent}
				confirmAction={confirmDialogData.confirmAction}
				cancelAction={confirmDialogData.cancelAction}
			/>


                <Hidden smDown>
					<Tooltip title='Account Management' aria-label='account_management'>
						<AppBarButton
							onClick={handleClick}
							startIcon={<AccountCircle className={iconClasses.iconProperties} />}
						>
							<UserNameTypography>{store.get("fullname")}</UserNameTypography>
						</AppBarButton>
					</Tooltip>
				</Hidden>

                <Hidden mdUp>
                    <div>
                        <Tooltip title='Account Management' aria-label='account_management'>
                            <IconButton aria-controls='simple-menu' aria-haspopup='true' onClick={handleClick}>
                                <AccountCircle className={iconClasses.iconProperties} />
                            </IconButton>
                        </Tooltip>
                    </div>
                </Hidden>

            {/* <div>
                <Tooltip title='Account Management' aria-label='user_account'>
                    <IconButton aria-controls='simple-menu' aria-haspopup='true' onClick={handleClick}>
                        <AccountCircle className={iconClasses.iconProperties} />
                        <div className={classes.usernameTextSmUp}><Hidden smDown><UserNameTypography>{store.get("fullname")}</UserNameTypography></Hidden></div>
                    </IconButton>
                </Tooltip>
            </div> */}

            <Menu
                id='menu-appbar'
                anchorEl={anchorEl}
                keepMounted
                getContentAnchorEl={null}
                anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                transformOrigin={{vertical: 'top', horizontal: 'center'}}
                open={open}
                onClose={handleClose}
            >
                {/* <Hidden mdUp>
                    <div className={classes.usernameText}><UserNameTypography>{store.get("fullname")}</UserNameTypography></div>
                    <Divider className={classes.divider} />
                </Hidden> */}

                {/* <MenuItem onClick={handleClose}>Profile</MenuItem> */}
                <MenuItem onClick={logoutConfirmAction}>Logout</MenuItem>
            </Menu>

        </Fragment>
    )
}


export default UserIcon